import React from 'react';
import LampThumbnail from './LampThumbnail';
import './DesignCard.css';

const DesignCard = ({ design, onEdit, onDelete, onAddToCart }) => (
  <div className="design-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#fff', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: '1rem', maxWidth: '220px', height: '400px' }}>
    <LampThumbnail design={design} alt={design.name || 'Design thumbnail'} />
    {design.ratings && design.ratings.score && (
      <div style={{ 
        margin: '0.5rem 0 0 0', 
        padding: '0.25rem 0.5rem', 
        background: design.ratings.score >= 6 ? '#e8f5e8' : '#ffe8e8',
        borderRadius: '4px',
        fontSize: '0.8rem',
        color: design.ratings.score >= 6 ? '#2d5a2d' : '#5a2d2d',
        fontWeight: 500
      }}>
        {design.ratings.score >= 6 ? '👍' : '👎'} Rating: {design.ratings.score}/10
      </div>
    )}
    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '100%' }}>
      <p style={{ margin: '0.5rem 0 1rem 0', color: '#666', fontSize: '0.95rem', textAlign: 'center' }}>Created: {new Date(design.createdAt).toLocaleDateString()}</p>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', width: '100%', justifyContent: 'center' }}>
      <button onClick={onEdit} style={{
        background: '#3498db',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '0.5rem 1rem',
        fontWeight: 600,
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'background 0.2s',
        boxShadow: '0 1px 3px rgba(52,152,219,0.08)',
        fontSize: '1rem'
      }}>
        Edit
      </button>
      <button onClick={onDelete} className="design-btn delete-btn" aria-label="Delete design">
        Delete
      </button>
      {onAddToCart && (
        <button
          onClick={onAddToCart}
          className="design-btn add-btn"
          aria-label="Add design to cart"
        >
          Add to Cart
        </button>
      )}
      </div>
    </div>
  </div>
);

export default DesignCard; 
